<!-- Zweck: Stellt die HTML-Struktur für shop verfuegbarkeits info button component im Frontend bereit. -->
<span matTooltip="{{not_available_de_no_pzn?'Verfügbarkeitsanfrage nicht verfügbar':''}}">
  @if ((vfchecknotloading$ | async)) {
    <button (click)="checkVerfuerbarkeit()"  (contextmenu)="showMenu($event)"
      [disabled]="disabled || not_available_de_no_pzn || (entry.freimenge == 0 && entry.menge == 0 && entry.aktionsrabattmenge == 0)"
      mat-icon-button matTooltip="Verfügbarkeitsabfrage{{(supplier|async)?.length > 1 ? ' (R-Klick für Lieferanten-Auswahl)':''}}">
      <svg-icon
        color="{{(disabled || not_available_de_no_pzn || (entry.freimenge == 0 && entry.menge == 0 && entry.aktionsrabattmenge == 0)) ? 'grey' : '#00acd6'}}">
        verfuegbarkeitsabfrage
      </svg-icon>
    </button>
  }

  @if ((vfcheckloading$ | async)) {
    <button [disabled]="true" mat-button style="top: 10px; left: 10px; width: 64px;">
      <div style="display: inline-block; position: relative; left: -10px; top: -5px">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </button>
  }
</span>
